<template>
<b-form>
  <h5>{{item.weekcaption}}</h5>

  <div v-if="!item.loadwait" class="weekedit d-flex flex-wrap flex-column align-items-start">
    <div class="onedaygroup" v-for="oneday in item.days" :key="oneday.caption" :style="{'border-color': colors[oneday.dayn]}">
      <p class="text-muted">{{oneday.caption}}</p>
      <b-form-group class="mb-0">
          <b-form-radio :disabled="oneday.closeday == 1" value="0" :name="oneday.caption" v-model="oneday.choice">None</b-form-radio>
          <b-form-radio :disabled="oneday.closeday == 1" class="mb-1" v-for="i in oneday.menu" :value="i.key" :key="i.key" v-model="oneday.choice" :name="oneday.caption">{{i.value}}</b-form-radio>
      </b-form-group>
    </div>
  </div>
  
  <b-alert v-if="item.error" class="mt-1" show variant="danger">{{item.error}}</b-alert>

  <div v-if="item.wait" class="d-flex mt-2">
      <b-spinner variant="primary"></b-spinner>
      <span class="ml-3 mt-1">Saving document, please wait...</span>
  </div>

  <div v-if="item.loadwait" class="text-center text-muted my-5">
      <b-spinner class="align-middle"></b-spinner>
      <strong>Loading...</strong>
  </div>          

</b-form>  
</template>

<script>
export default {
  props: ['item','colors'],
};
</script>

<style>
.onedaygroup{
  background-color: rgba(233, 232, 248, 0.5);
  width: 45%;
  min-height: 150px;
  margin: 10px 5px;
  border-left: 4px solid;
  padding: 8px;
  line-height: 1.2; 
}
.onedaygroup p{
    font-size: 0.9rem; 
}
.weekedit{
    max-height: 600px;
} 
@media screen and (max-width:1200px) {
   .weekedit{
       max-height: 1800px;
   }
   .onedaygroup{
       width: 100%;
       margin: 10px 0;
   }
}
</style>


// WEBPACK FOOTER //
// src/LunchOrderItem.vue